import { useState, useEffect, useCallback } from "react";
import type { MapaAtasResponse } from "../../types/database";
import { toast } from "../lib/toast";
import { api } from "../lib/api";

export interface UseMapaAtasOptions {
  projetoId: number;
  autoLoad?: boolean;
}

export interface UseMapaAtasResult {
  data: MapaAtasResponse | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}


export function useMapaAtas({ 
  projetoId, 
  autoLoad = true 
}: UseMapaAtasOptions): UseMapaAtasResult {
  const [data, setData] = useState<MapaAtasResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMapaAtas = useCallback(async () => {
    if (!projetoId || projetoId <= 0) {
      setError("ID do projeto inválido");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await api.get<MapaAtasResponse>(
        `/projetos/${projetoId}/mapa-atas`
      );

      setData(response.data);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Erro desconhecido";
      setError(errorMessage);
      toast.error(errorMessage);
      console.error("Erro ao buscar mapa de atas:", err);
    } finally {
      setLoading(false);
    }
  }, [projetoId]);

  useEffect(() => {
    if (autoLoad) {
      fetchMapaAtas();
    }
  }, [autoLoad, fetchMapaAtas]);

  return {
    data,
    loading,
    error,
    refetch: fetchMapaAtas,
  };
}
